import { Veiculo } from "#/types";

export const mockVeiculos: Veiculo[] = [
  {
    codigoFipe: "0016109",
    placa: "FDL0H00",
    chassi: "9BRTESTEEXV010111",
    descricao: "VERSA SL 1.6 16V FLEX FUEL MEC 4P",
    anoModelo: ["2013"],
    anoFabricacao: ["2012"],
  },
  {
    placa: "DGH9011",
    chassi: "9BD99439XG9153469",
    anoFabricacao: ["2016"],
    anoModelo: ["2016"],
    codigoFipe: "001372-3",
    descricao: "PALIO ATTRACTIVE 1.0 EVO FIRE FLEX 8V 5P (GAS.)",
  },
  {
    placa: "DGH9011",
    chassi: "9BD99439XG9153469",
    anoFabricacao: ["2016"],
    anoModelo: ["2016"],
    codigoFipe: "001372-2",
    descricao: "PALIO WEEKEND ADVENTURE 1.8 MPI FLEX 4P",
  },
  {
    placa: "DGH9000",
    chassi: "9BD99439XG9150000",
    anoFabricacao: ["2016", "2017"],
    anoModelo: ["2016", "2017"],
    codigoFipe: "001372-2",
    descricao: "PALIO WEEKEND ADVENTURE 1.8 MPI FLEX 4P",
  },
];
